const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: '800px',
    marginBottom: '60px',
    position: 'relative',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #E0E0E0',
  },
  pageDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0px',
    position: 'sticky',
    top: '60px',
    backgroundColor: '#F4F6F8',
    zIndex: 3,
  },
  pageDetailsSwitch: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
    '&:hover': {},
  },
  sectionHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '24px 16px 16px 8px',
    cursor: 'pointer',
    borderBottom: '1px solid #E5E7EB',
  },
  dragHandle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  dragHandleRotated: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  dragIcon: {
    color: '#838D98',
    fontSize: '20px',
  },
  dragIconRotate: {
    color: '#838D98 !important',
    fontSize: '20px',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 500,
    flex: 1,
    transition: 'color 0.2s ease',
    outline: 'none',
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
    '&[data-placeholder]:empty:before': {
      content: 'attr(data-placeholder)',
      color: '#838D98',
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
  sectionTitleInput: {
    flex: 1,
    margin: '0px !important',
    padding: '0px !important',
    minHeight: '22px',
    fontSize: '15px',
    fontWeight: 500,
    outline: 'none',
    border: 'none',
    lineHeight: '1.4',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    marginLeft: theme.spacing(1),
  },
  flexGrow: {
    flexGrow: 1,
  },
  expandButton: {
    color: '#637381',
    transition: 'transform 0.2s ease, color 0.2s ease',
    '&:hover': {},
  },
  expandedIcon: {
    transform: 'rotate(180deg)',
    color: '#002E47',
  },
  sectionContent: {
    padding: theme.spacing(2),
  },
  pageContainer: {
    backgroundColor: '#FFFFFF',
    marginBottom: theme.spacing(2),
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  pageTitleText: {
    flex: 1,
    marginLeft: theme.spacing(0.5),
    fontSize: '14px',
    fontWeight: 500,
    transition: 'color 0.2s ease',
    outline: 'none',
    position: 'relative',
    '&:hover': {},
    '&[data-placeholder]:empty:before': {
      content: 'attr(data-placeholder)',
      color: '#838D98',
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
  pageTitleInput: {
    flex: 1,
    margin: '0px !important',
    padding: '0px !important',
    minHeight: '22px',
    fontSize: '14px',
    fontWeight: 500,
    outline: 'none',
    border: 'none',
    lineHeight: '1.4',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    marginLeft: theme.spacing(1),
  },
  deleteButton: {
    color: '#637381',
    padding: theme.spacing(0.5),
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      color: '#D32F2F',
    },
    '&.Mui-disabled': {
      color: '#BDBDBD',
      cursor: 'not-allowed',
    },
  },
  pageContent: {
    padding: '8px 0px 8px 0px',
    marginLeft: '24px',
  },
  goalsLabel: {
    fontSize: '14px',
    fontWeight: 400,

    marginBottom: theme.spacing(1.5),
  },
  goalsList: {
    marginBottom: theme.spacing(2),
  },
  goalItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    borderRadius: '4px',
  },
  goalNumber: {
    fontSize: '14px',
    fontWeight: 400,
    minWidth: '20px',
  },
  goalText: {
    fontSize: '14px',
    fontWeight: 400,
    flex: 1,
    outline: 'none',
    '&[data-placeholder]:empty:before': {
      content: 'attr(data-placeholder)',
      color: '#838D98',
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
  goalInput: {
    flex: 1,
    margin: '0px !important',
    padding: '0px !important',
    minHeight: '21px',
    fontSize: '14px',
    fontWeight: 400,
    outline: 'none',
    border: 'none',
    lineHeight: '1.4',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  removeGoalButton: {
    color: '#637381',
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      color: '#D32F2F',
    },
  },
  addGoalContainer: {
    marginTop: theme.spacing(1.5),
  },
  addGoalInput: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      transition: 'border-color 0.2s ease',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#015ffb',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#015ffb',
      },
    },
  },
  fileInfo: {
    display: 'flex',
    padding: '8px 0px',
    borderRadius: '0px',
    borderTop: '1px solid #E5E7EB',
    marginTop: theme.spacing(1.5),
  },
  fileIcon: {
    color: '#002E47',
    fontSize: '16px',
    minWidth: '16px',
    marginRight: theme.spacing(1),
  },
  fileText: {
    fontSize: '12px',
    color: '#637381',
    fontWeight: 400,
  },
  addPageButton: {
    color: '#637381',
    textTransform: 'none',
    padding: theme.spacing(1, 2),
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
    },
  },
  addSectionButton: {
    backgroundColor: '#fff',
  },
  sectionHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    gap: theme.spacing(1),
  },
  sectionMenuButton: {
    color: '#637381',
    padding: theme.spacing(0.5),
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      color: '#015ffb',
    },
  },
  sectionMenu: {
    '& .MuiPaper-root': {
      boxShadow: '0 2px 4px 0 rgba(145, 158, 171, 0.1)',
      borderRadius: '8px',
    },
  },
  sectionMenuItem: {
    fontSize: '14px',
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },

  popupContent: {
    padding: '8px',
  },
  popupTitle: {
    color: '#637381',
  },
  suggestionList: {
    padding: 0,
    maxHeight: '200px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  popupTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
  },
  suggestionItem: {
    borderRadius: '8px',
    padding: '12px 8px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
    '&:last-child': {
      marginBottom: theme.spacing(1),
    },
  },
  suggestionItemIcon: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '24px',
    height: '24px',
    minWidth: '24px',
    minHeight: '24px',
    [theme.breakpoints.down('md')]: {
      width: '16px',
      height: '16px',
      minWidth: '16px',
      minHeight: '16px',
    },
  },
  suggestionText: {
    color: '#637381',
    lineHeight: 1.4,
  },
  generateCourseButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    position: 'sticky',
    bottom: '16px',
    left: '0',
    right: '0',
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
})

export default styles
